module.exports = __webpack_public_path__ + "img/consents_pretasks.e4af15a8.png";